import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import i18n from "./i18n";
import router from "./router";
import App from "./App.vue";
import VueMatomo from "vue-matomo"; // 確認此套件支援 Vue 3

// Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";

// 全域樣式
import "@/assets/styles/app.scss";

// 1. 初始化應用程式
const app = createApp(App);

// 2. 設定 Pinia
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

// 3. 使用插件
app.use(pinia);
app.use(router);
app.use(i18n);

// 4. 設定 Matomo (Vue 3 插件用法)
const matomoSiteIDs = {
  DNA: { development: 6, production: 5 },
  ARISTO: { development: 2, production: 1 },
};
const _theme = import.meta.env.VITE_APP_THEME ?? "ARISTO";
const _mode =
  import.meta.env.MODE === "development" ? "development" : "production";

app.use(VueMatomo, {
  host: "https://ga.lc9527.com/",
  siteId: matomoSiteIDs[_theme]?.[_mode] ?? 1,
  router: router,
  enableLinkTracking: true,
  requireConsent: false,
  trackInitialView: true,
});

// 5. 掛載到 DOM
app.mount("#app");
